import { createSlice } from "@reduxjs/toolkit";
import {
  getJobList,
  getSearchLogs,
  getStats,
  getFeedbackChart,
  getFeedbackChartByNumber,
  getEmailLogs,
} from "./StatsActions";

interface StatsState {
  allstats_loading: boolean;
  allstats_data: any;
  allstats_error: any | null;

  stats_charts_loading: boolean;
  stats_charts_data: any;
  stats_charts_error: any | null;

  search_logs_loading: boolean;
  search_logs_data: any;
  search_logs_error: any | null;

  email_logs_loading: boolean;
  email_logs_data: any;
  email_logs_error: any | null;

  job_list_loading: boolean;
  job_list_data: any;
  job_list_error: any | null;

  feedback_chart_loading: boolean;
  feedback_chart_data: any;
  feedback_chart_error: any | null;

  feedback_chart_by_number_loading: boolean;
  feedback_chart_by_number_data: any;
  feedback_chart_by_number_error: any | null;


}

const initialState: StatsState = {
  allstats_loading: false,
  allstats_data: null,
  allstats_error: null,

  stats_charts_loading: false,
  stats_charts_data: null,
  stats_charts_error: null,

  search_logs_loading: false,
  search_logs_data: null,
  search_logs_error: null,

  email_logs_loading: false,
  email_logs_data: null,
  email_logs_error: null,

  job_list_loading: false,
  job_list_data: null,
  job_list_error: null,

  feedback_chart_loading: false,
  feedback_chart_data: null,
  feedback_chart_error: null,

  feedback_chart_by_number_loading: false,
  feedback_chart_by_number_data: null,
  feedback_chart_by_number_error: null,
};

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStats.pending, (state) => {
        state.allstats_loading = true;
        state.allstats_data = null;
        state.allstats_error = null;
      })
      .addCase(getStats.fulfilled, (state, action) => {
        state.allstats_loading = false;
        state.allstats_data = action.payload;
        state.allstats_error = null;
      })
      .addCase(getStats.rejected, (state, action) => {
        state.allstats_loading = false;
        state.allstats_data = null;
        state.allstats_error = action.payload;
      });

    builder
      .addCase(getSearchLogs.pending, (state) => {
        state.search_logs_loading = true;
        state.search_logs_data = null;
        state.search_logs_error = null;
      })
      .addCase(getSearchLogs.fulfilled, (state, action) => {
        state.search_logs_loading = false;
        state.search_logs_data = action.payload?.data;
        state.search_logs_error = null;
      })
      .addCase(getSearchLogs.rejected, (state, action) => {
        state.search_logs_loading = false;
        state.search_logs_data = null;
        state.search_logs_error = action.payload;
      });

    builder
      .addCase(getEmailLogs.pending, (state) => {
        state.email_logs_loading = true;
        state.email_logs_data = null;
        state.email_logs_error = null;
      })
      .addCase(getEmailLogs.fulfilled, (state, action) => {
        state.email_logs_loading = false;
        state.email_logs_data = action.payload?.data;
        state.email_logs_error = null;
      })
      .addCase(getEmailLogs.rejected, (state, action) => {
        state.email_logs_loading = false;
        state.email_logs_data = null;
        state.email_logs_error = action.payload;
      });

    builder
      .addCase(getJobList.pending, (state) => {
        state.job_list_loading = true;
        state.job_list_data = null;
        state.job_list_error = null;
      })
      .addCase(getJobList.fulfilled, (state, action) => {
        state.job_list_loading = false;
        state.job_list_data = action.payload?.data;
        state.job_list_error = null;
      })
      .addCase(getJobList.rejected, (state, action) => {
        state.job_list_loading = false;
        state.job_list_data = null;
        state.job_list_error = action.payload;
      });

    builder
      .addCase(getFeedbackChart.pending, (state) => {
        state.feedback_chart_loading = true;
        state.feedback_chart_data = null;
        state.feedback_chart_error = null;
      })
      .addCase(getFeedbackChart.fulfilled, (state, action) => {
        state.feedback_chart_loading = false;
        state.feedback_chart_data = action.payload;
        state.feedback_chart_error = null;
      })
      .addCase(getFeedbackChart.rejected, (state, action) => {
        state.feedback_chart_loading = false;
        state.feedback_chart_data = null;
        state.feedback_chart_error = action.payload;
      });

    builder
      .addCase(getFeedbackChartByNumber.pending, (state) => {
        state.feedback_chart_by_number_loading = true;
        state.feedback_chart_by_number_data = null;
        state.feedback_chart_by_number_error = null;
      })
      .addCase(getFeedbackChartByNumber.fulfilled, (state, action) => {
        state.feedback_chart_by_number_loading = false;
        state.feedback_chart_by_number_data = action.payload;
        state.feedback_chart_by_number_error = null;
      })
      .addCase(getFeedbackChartByNumber.rejected, (state, action) => {
        state.feedback_chart_by_number_loading = false;
        state.feedback_chart_by_number_data = null;
        state.feedback_chart_by_number_error = action.payload;
      });
  },
});

const statsReducer = statsSlice.reducer;

export default statsReducer;
